import React from "react";
import MainLayout from "../../Layout/mainLayout";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import { addNewCategory } from "../../Redux/Actions/categoryActions";
import TextInput from "../../Global Functions/textInput";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import toast from "react-hot-toast";

const AddSubCategories = () => {
  const { id } = useParams();

  const [subCategory, setSubCategory] = useState({
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    image: "",
    parent: id,
    three_d_icon: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleImageUpload = async (event, type) => {
    const uploadedFile = event.target.files[0];

    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);

    if (responseUrl) {
      setSubCategory((prevData) => ({ ...prevData, [type]: responseUrl }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const filteredData = Object.fromEntries(
        Object.entries(subCategory).filter(
          ([key, value]) =>
            value !== "" && value !== null && value !== undefined
        )
      );
      const response = await dispatch(addNewCategory(filteredData));
      if (response.statusCode === 200) {
        navigate(`/categories/view/${id}`);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.data?.response?.message);
    }
  };

  return (
    <MainLayout>
      <div
        style={{
          marginTop: "10px",
          padding: "20px",
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h1>Add Sub Category</h1>
          <Link to={`/categories/view/${id}`}>
            <button className="button-class">View Sub-Category List</button>
          </Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Sub-Category's Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="image"
                id="image"
                onChange={(event) => handleImageUpload(event, "image")}
              />
              <label className="label-class-image" for="image">
                Click To Upload Image
              </label>

              <ImageShowerModalGlobal
                file={subCategory.image}
                setState={setSubCategory}
                state={subCategory}
                keyField="image"
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Upload Sub-Category's Icon</span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="icon"
                id="icon"
                onChange={(event) => handleImageUpload(event, "icon")}
              />
              <label className="label-class-image" for="icon">
                Click To Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCategory.icon}
                setState={setSubCategory}
                state={subCategory}
                keyField="icon"
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                value={subCategory.name}
                label="Sub Category Name"
                placeholder="Enter Name"
                onChange={(event) => {
                  setSubCategory({ ...subCategory, name: event.target.value });
                }}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Upload 3D Icon</span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="three_d_icon"
                id="three_d_icon"
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
              />
              <label className="label-class-image" for="three_d_icon">
                Click To Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCategory.three_d_icon}
                setState={setSubCategory}
                state={subCategory}
                keyField="three_d_icon"
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-end" style={{ margin: "20px auto" }}>
            <Link to={`/categories/view/${id}`}>
              <button className="button-class-white">Cancel</button>
            </Link>
            <button className="button-class" type="submit">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddSubCategories;
